import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import DataTable, { TableStyles } from 'react-data-table-component';

import { useNavigate } from "react-router-dom";
import { OverlayPanel } from "primereact/overlaypanel";

import moment from "moment";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import GridPanel from "./grid-panel";

import Helpers from "../../../../utils/helpers";
import { BsEmojiWink } from "react-icons/bs";
import TokenService from "../../../../services/autentication/token.service";
import CameraOperatorsService from "../../../../services/AuraCamera/camera-operators/camer-operators.service";
import { Toast } from "primereact/toast";
import {
  ConfirmDialog,
  confirmDialog as DeleteOperatorDialog,
} from "primereact/confirmdialog";

interface ColumnDef {
  header?: string;
  body?: any;
  name?: any;
  cell?: any;
  selector?: any;
  sortable?: boolean;
  style?: any;
  width?: any;
}
const dataTableStyles: TableStyles = {
  subHeader: {
    style: {
      paddingLeft: "0",
      paddingRight: "0",
    },
  },
  head: {
    style: {
      height: "38px",
      opacity: "1",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#e5e5e5",
      borderTop: "1px solid rgba(0,0,0,0.07)",
      justifyContent: "space-between",
      fontWeight: "bold",
      paddingLeft: "13px",
      paddingRight: "13px",
      height: "38px",
      opacity: "1",
    },
  },
  cells: {
    style: {
      /* borderLeft: "1px solid rgba(0,0,0,0.07)",
        "&:last-of-type": {
          borderRight: "1px solid rgba(0,0,0,0.07)",
        }, */
      background: "transparent",
      borderBottom: "#D0D0CE",
      paddingLeft: "13px",
      paddingRight: "13px",
      minHeight: "38px",
    },
  },
};

interface Customer {
  SurveyName?: string;
  name?: string;
  Date?: string;
  Status?: any;
  Source?: any;
  Size?: any;
  Percent?: number;
}

const Table = (props: any) => {
  const session = window.localStorage;
  const { t } = useTranslation();
  const toast = useRef<any>(null);
  var navigate = useNavigate();
  const [filterText, setFilterText] = useState("");
  const [currentPageData, setCurrentPageData] = useState<Customer[]>(
    props?.filteredValues
  );
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const [visible, setVisible] = useState(false);
  const [DeleteID, setDeleteID] = useState<any>(null);
  const showDialog = () => {
    setVisible(true);
  };

  const hideDialog = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    // Add your logic here to add two numbers
    CameraOperatorsService.DeleteCameraOperatorsData(DeleteID).then(
      (res: any) => {
        if (res == "success") {
          session.setItem("setCameraOperatorDeleteToastFlag", "true");
          window.location.href = window.location.href;
        }
      }
    );
    hideDialog();
  };

  const onHide = () => {
    hideDialog();
  };

  useEffect(() => {
    setCurrentPageData(props?.filteredValues);
  }, [props]);
  const showToast = (
    severityValue: any,
    summaryValue: any,
    detailValue: any
  ) => {
    toast?.current?.clear();
    toast?.current?.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };
  useEffect(() => {
    if (session.getItem("setCameraOperatorDeleteToastFlag") == "true") {
      session.setItem("setCameraOperatorDeleteToastFlag", "false");

      showToast(
        "error",
        "Camera opertor deleted",
        "Camera opertor deleted successfully."
      );
    }
  }, []);

  const getUser = TokenService.getUser();
  const DetailButtonOverlay = (data: any) => {
    const selectDaysDpDown = useRef<any>(null);

    return (
      <>
        <i
          className="pi pi-ellipsis-v"
          style={{ fontSize: "1.5em", cursor: "pointer" }}
          onClick={(e) => selectDaysDpDown.current.toggle(e)}
        ></i>
        <OverlayPanel className="popup-block" ref={selectDaysDpDown}>
          <ul style={{}}>
            <li style={{}}>
              <a
                href="javascript:void(0);"
                onClick={() => {
                  showDialog();
                  setDeleteID(data?.row?.userID);
                }}
              >
                Delete
              </a>
              <span className="material-symbols-outlined" style={{}}>
                keyboard_arrow_right
              </span>
            </li>
            <li style={{}}>
              <a
                href="javascript:void(0);"
                onClick={() => {
                  navigate(
                    `/aura-camera/camera-operator-creation/${data?.row?.userID}`
                  );
                }}
              >
                Edit
              </a>
              <span className="material-symbols-outlined" style={{}}>
                keyboard_arrow_right
              </span>
            </li>
          </ul>
        </OverlayPanel>
      </>
    );
  };

  // Columns setting start
  const columns: ColumnDef[] = [
    // {
    //   name: "Site ID",
    //   selector: (row: any) => row.siteID,
    //   cell: (row: any) => {
    //     return <>{row.siteID}</>;
    //   },
    //   sortable: true,
    //   // width: '19%'
    // },

    {
      name: "Company",
      selector: (row: any) => {
        let temp_site_name = row.company;
        temp_site_name = temp_site_name?.toString().toLowerCase();

        // if (temp_site_name == null || temp_site_name == undefined) {
        //   temp_site_name = "";
        // }

        return temp_site_name;
      },
      cell: (row: any) => {
        return <>{row.company}</>;
      },
      sortable: true,
      // width: '11%'
    },
    {
      name: "Name",
      selector: (row: any) => {
        let temp_area = row.name;
        temp_area = temp_area?.toString().toLowerCase();
        if (temp_area == null || temp_area == undefined) {
          temp_area = "";
        }

        return temp_area;
      },
      cell: (row: any) => {
        return row.name;
      },
      sortable: true,
      // width: '10%',
    },

    {
      name: "Email",
      selector: (row: any) => {
        let temp_email = row.email;
        temp_email = temp_email?.toString().toLowerCase();
        return temp_email;
      },
      cell: (row: any) => {
        return row.email;
      },
      // width: "28%"
      sortable: true,
    },

    {
      name: "Contact number",
      selector: (row: any) => {
        let temp_operator = row.contact_number;
        if (temp_operator == null || temp_operator == undefined) {
          temp_operator = "";
        }

        return temp_operator;
      },
      cell: (row: any) => {
        return row.contact_number;
      },
      // width: "22%",
      sortable: true,
    },
    // {
    //   name: "OGI initail training",
    //   selector: (row: any) => {
    //     let temp_cameraName = row.ogi_initial_training;
    //     if (temp_cameraName == null || temp_cameraName == undefined) {
    //       temp_cameraName = "";
    //     }

    //     return temp_cameraName;
    //   },
    //   cell: (row: any) => {
    //     return row.ogi_initial_training;
    //   },
    //   sortable: true,
    //   // width: "10%"
    // },
    {
      name: "Initial training date",
      selector: (row: any) => {
        // row.initialTrainingDate
        return Helpers.convertUTCtoMMDDYYYY(row.initialTrainingDate);
      },
      cell: (row: any, index: number, column: any, id: number) => {
        return Helpers.convertUTCtoMMDDYYYY(row.initialTrainingDate);
      },
      sortable: true,
      // width: "5%"
    },
    {
      name: "Last training date",
      selector: (row: any) => {
        if(row.lastTrainingDate != null){
          return Helpers.convertUTCtoMMDDYYYY(row.lastTrainingDate);

        }else{
          return <></>
        }
      },
      cell: (row: any, index: number, column: any, id: number) => {
        if(row.lastTrainingDate != null){
          return Helpers.convertUTCtoMMDDYYYY(row.lastTrainingDate);

        }else{
          return <></>
        }
      },
      sortable: true,

      // width: "5%"
    },

    {
      name: "Refresher training",
      selector: (row: any) => {
        let temp_cameraName = row.ogI_Refreshing_Time;
        if (temp_cameraName == null || temp_cameraName == undefined) {
          temp_cameraName = "";
        }

        return temp_cameraName;
      },
      cell: (row: any, index: number, column: any, id: number) => {
        return <>{row.ogI_Refreshing_Time}</>;
      },
      sortable: true,
      // width: "5%"
    },

    {
      name: "Total operating hours",
      selector: (row: any) => {
        let temp_cameraName = row.total_Training_Hours;
        if (temp_cameraName == null || temp_cameraName == undefined) {
          temp_cameraName = 0;
        }

        return temp_cameraName;
      },
      cell: (row: any, index: number, column: any, id: number) => {
        let temp_cameraName = row.total_Training_Hours;
        if (temp_cameraName == null || temp_cameraName == undefined) {
          temp_cameraName = 0;
        }

        return temp_cameraName;
      },
      sortable: true,
      // width: "5%"
    },
    // {
    //   name: "",
    //   cell: (row: any, index: number, column: any, id: number) => {
    //     return (
    //       <>
    //         {getUser?.superAdmin === true || getUser?.globalAdmin == true ? (
    //           <DetailButtonOverlay row={row} />
    //         ) : (
    //           ""
    //         )}
    //       </>
    //     );
    //   },

    //   width: "5%",
    // },
  ];
  // Columns setting end

  var liveData: any = currentPageData?.length > 0 ? currentPageData : [];

  const filteredItems = liveData?.filter((item: any) => {
    let regex = /"(\\.|[^"\\])*"/g;
    var exactMatchText: any =
      filterText != null
        ? filterText.match(regex)?.[0].replace(/"/g, "")
        : null;

    if (exactMatchText) {
      let temp_last_date = Helpers.convertUTCtoMMDDYYYY(item?.lastTrainingDate);
      let temp_initial_date = Helpers.convertUTCtoMMDDYYYY(
        item?.initialTrainingDate
      );
      return (
        item?.company?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.name?.toString().toLowerCase() == exactMatchText?.toLowerCase() ||
        item?.email?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.contact_number?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        // item?.ogi_initial_training?.toString().toLowerCase() ==
        //   exactMatchText?.toLowerCase() ||
        temp_initial_date == exactMatchText?.toLowerCase() ||
        // Helpers.convertUTCtoMMDDYYYY(row.lastTrainingDate)
        temp_last_date == exactMatchText?.toLowerCase() ||
        item?.ogI_Refreshing_Time?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.total_Training_Hours?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase()
      );
    } else {
      let temp_last_date = Helpers.convertUTCtoMMDDYYYY(item?.lastTrainingDate);
      let temp_initial_date = Helpers.convertUTCtoMMDDYYYY(
        item?.initialTrainingDate
      );
      return (
        item?.company
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.name
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.email
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.contact_number
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        temp_initial_date.includes(filterText?.toLowerCase()) ||
        temp_last_date.includes(filterText?.toLowerCase()) ||
        item?.ogI_Refreshing_Time
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.total_Training_Hours
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase())
      );
    }
  });

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      // <FilterComponent onFilter={(e: any) => setFilterText(e?.target?.value)} onClear={handleClear} filterText={filterText} />

      <div className="col-md-12" style={{ marginBottom: "10px" }}>
        <div
          className="d-flex flex-row  justify-content-start align-items-center table-search"
          style={{ maxWidth: "400px" }}
        >
          <label className="custom_common_label">
            {t("SearchLabel")}: &nbsp;&nbsp;&nbsp;{" "}
          </label>
          <div className="inputGroup">
            <div className="input-block">
              <input
                type="text"
                name="sitebulkuploadsearch"
                id="sitebulkuploadsearch"
                className="form-control input-sm"
                autoComplete="off"
                onChange={(e: any) => setFilterText(e?.target?.value)}
                value={filterText}
              />
              <span className="material-symbols-outlined">search</span>
            </div>
            <div className="searchClear">
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => handleClear()}
              >
                {" "}
                X
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }, [filterText, resetPaginationToggle]);
  return (
    <>
      <ConfirmDialog
        visible={visible}
        onHide={onHide}
        message="Do you want to delete the operator?"
        header="Confirmation"
        icon="pi pi-info-circle"
        acceptClassName="p-button-success"
        acceptLabel="Yes"
        rejectClassName="p-button-danger"
        rejectLabel="No"
        accept={onConfirm}
        reject={onHide}
      />

      <Toast ref={toast} style={{ marginTop: "25px", zIndex: 9999 }} />
      {getUser?.superAdmin === true || getUser?.globalAdmin == true ? (
        <div className="site-table_btn">
          {/* <button
            className="btn btn-primary"
            onClick={() => {
              navigate(`/aura-camera/camera-operator-creation`);
            }}
          >
            Add new
          </button> */}
        </div>
      ) : (
        ""
      )}

      {props.isGrid && props.isGrid ? (
        <div className="grid-block  sites-grid-block" id="grid-block">
          <div className="row">
            <GridPanel
              filteredItems={liveData}
              //   selectDaysDpDown={selectDaysDpDown1}
            />
          </div>
        </div>
      ) : (
        <div className="table-responsive" id="table-block">
          <DataTable
            columns={columns}
            data={filteredItems}
            highlightOnHover={true}
            // defaultSortFieldId="3"
            // defaultSortAsc={false}
            pagination={true}
            subHeader
            subHeaderComponent={
              liveData?.length > 0 ? subHeaderComponentMemo : []
            }
            responsive={true}
            striped={true}
            className={"cusTableRes"}
            // paginationPerPage={5}
            // paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
            customStyles={dataTableStyles}
            // sortIcon={sortIcon}
          />
        </div>
      )}
    </>
  );
};

export default Table;
